import { useState, useEffect } from 'react';

export const BootScreen = ({ onBootComplete, playSound }) => {
  const [progress, setProgress] = useState(0);
  const [showSkip, setShowSkip] = useState(false);

  useEffect(() => {
    // Show skip button after 2 seconds
    const skipTimer = setTimeout(() => {
      setShowSkip(true);
    }, 2000);

    // Progress bar animation
    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(progressInterval);
          return 100;
        }
        return prev + 2;
      });
    }, 100);

    // Auto-complete after 5 seconds
    const bootTimer = setTimeout(() => {
      playSound('startup', 0.3);
      onBootComplete();
    }, 5500);

    return () => {
      clearTimeout(skipTimer);
      clearTimeout(bootTimer);
      clearInterval(progressInterval);
    };
  }, [onBootComplete, playSound]);

  const handleSkip = () => {
    playSound('startup', 0.3);
    onBootComplete();
  };

  return (
    <div className="boot-screen" data-testid="boot-screen">
      <div className="boot-content">
        {/* WinBlows XP Logo */}
        <div className="xp-logo">
          <div className="xp-flag">
            <div className="flag-segment red"></div>
            <div className="flag-segment green"></div>
            <div className="flag-segment blue"></div>
            <div className="flag-segment yellow"></div>
          </div>
          <div className="xp-text">
            <span className="microsoft">Microshaft</span>
            <span className="windows">
              WinBlows<sup>®</sup><span className="xp">XP</span>
            </span>
          </div>
        </div>

        {/* Loading Bar */}
        <div className="boot-loading">
          <div className="loading-bar">
            <div className="loading-segments">
              {[...Array(3)].map((_, i) => (
                <div
                  key={i}
                  className="loading-segment"
                  style={{
                    animationDelay: `${i * 0.2}s`,
                  }}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Progress text */}
        <p className="boot-text">Loading WinBlows... Please wait. Or don't. We don't care.</p>

        {/* Skip Button */}
        {showSkip && (
          <button
            className="skip-button"
            onClick={handleSkip}
            data-testid="skip-boot-button"
          >
            Press any key or click to skip
          </button>
        )}
      </div>

      {/* Copyright */}
      <div className="boot-copyright">
        <p>Copyright © Microshaft Corporation. All your data belong to us.</p>
      </div>
    </div>
  );
};

export default BootScreen;
